import { render, staticRenderFns } from "./materialListDialog.vue?vue&type=template&id=6d2f128b&scoped=true"
import script from "./materialListDialog.vue?vue&type=script&lang=js"
export * from "./materialListDialog.vue?vue&type=script&lang=js"
import style0 from "./materialListDialog.vue?vue&type=style&index=0&id=6d2f128b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f128b",
  null
  
)

export default component.exports